exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".leaflet-object-info .leaflet-popup-content{margin:8px;max-height:450px;overflow:auto}.leaflet-object-info .leaflet-popup-close-button{color:#676a6c!important}.leaflet-object-info__item{padding:.5rem}.leaflet-object-info__item__title,.leaflet-object-info__item__topic{display:block;font-weight:700;font-size:12px;color:#676a6c}.leaflet-object-info__item__icon{margin-right:1rem;width:24px;height:24px;object-fit:contain}.leaflet-object-info__item__title{font-weight:400}.leaflet-object-info__item__error,.leaflet-object-info__item__nodata{display:block;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /builds/landesanstalt-fuer-umwelt-baden-wuerttemberg/fliwas/fliwas-three/~/css-loader!/builds/landesanstalt-fuer-umwelt-baden-wuerttemberg/fliwas/fliwas-three/~/sass-loader!./js/css/object-info.scss
// module id = 88
// module chunks = 4